<div class="max-w-4xl mx-auto py-10 px-6 md:px-8">
    <!-- Header Section -->
    <div class="text-center mb-10">
        <h1 class="text-3xl font-bold text-primary mb-2">Privacy Policy</h1>
        <p class="text-sm italic">Last Updated: April 2025</p>
    </div>

    <!-- Table of Contents -->
    <!-- <div class="bg-gray-50 p-6 rounded-lg mb-10 shadow-sm">
        <h2 class="text-xl font-semibold mb-4">Quick Navigation</h2>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            <a [routerLink]="['/']" fragment="objective"  class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Objective & Scope</a>
            <a href="#collection" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> How We Collect Information</a>
            <a [routerLink]="['/']" fragment="#information" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Information We Collect</a>
            <a [routerLink]="['/']" fragment="#purpose" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Purpose of Collection</a>
            <a [routerLink]="['/']" fragment="#sharing" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> How We Share Information</a>
            <a [routerLink]="['/']" fragment="#retention" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Retention of Information</a>
            <a [routerLink]="['/']" fragment="#opting" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Opting Out</a>
            <a [routerLink]="['/']" fragment="#cookies" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Use of Cookies</a>
            <a [routerLink]="['/']" fragment="#security" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Security Measures</a>
            <a [routerLink]="['/']" fragment="#concerns" class="text-primary hover:underline flex items-center"><span class="mr-2">•</span> Privacy Concerns</a>
        </div>
    </div> -->

    <!-- Objective & Scope Section -->
    <section  id="objective" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Objective, Scope, and Applicability</h2>
        </div>
        
        <div class="space-y-4">
            <p>MASHHOOR PLUS ("Company," "we," "our," "us") values the privacy of individuals and is dedicated to safeguarding it. This Privacy Policy ("Policy") outlines how we collect, utilize, disclose, and transfer Personal Information through the platforms we control, such as our website mashhoorplus.in and mobile sites (collectively referred to as the "Platforms").</p>
            
            <p>This Policy applies to individuals who:</p>
            <ul class="list-disc pl-6 space-y-2">
                <li>Visit, access, or interact with the Platform</li>
                <li>Provide their details via the Platform</li>
                <li>Whose information we gather, receive, or process in relation to the sale and offering of our products ("Products")</li>
            </ul>
            
            <div class="bg-gray-50 p-4 rounded-md mt-4">
                <p class="font-medium">Please Note:</p>
                <ul class="list-disc pl-6 mt-2 space-y-2">
                    <li>This Policy does not cover Personal Information obtained offline (unless specified)</li>
                    <li>Information from websites not linking to this Policy</li>
                    <li>Customers outside India</li>
                    <li>Third-party websites that our Platform may link to</li>
                </ul>
            </div>
            
            <div class="bg-yellow-50 border-l-4 border-yellow-500 p-4 my-4">
                <p>By using our Platform and providing your information as described in this Policy, you agree to the collection and use of the information you provide in accordance with this Policy. If you do not agree with the terms outlined in this Policy, you have the option to stop using the Platform.</p>
            </div>
            
            <p>Furthermore, by providing your mobile number, you consent to receive communications related to our services, even if that number is registered with the Do Not Disturb (DND) list or National Customer Preference Register (NCPR) under the Telecom Regulatory Authority of India (TRAI) Regulations, 2018. You confirm that these communications will not be considered unsolicited, as per TRAI's regulations, and acknowledge your specific choice to receive such communications on the mobile number you provided.</p>
            
            <div class="mt-4">
                <p class="font-medium">Definition of "Personal Information":</p>
                <p class="mt-2">For the purpose of this Policy, "Personal Information" refers to any information that is directly or indirectly related to you, which can identify you either alone or in combination with other information available to the Company. This information may be collected and stored by the Company through the Platform.</p>
                <p class="mt-2">However, information that is publicly available, accessible in the public domain, or shared under the Right to Information Act, 2005, or any other applicable law, is not considered Personal Information under this Policy.</p>
            </div>
        </div>
    </section>

    <!-- How We Collect Section -->
    <section id="collection" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">How Do We Collect Your Personal Information?</h2>
        </div>
        
        <p>We communicate with you through various channels such as our Platform, email, phone, or text messages on your mobile device. However, email is our preferred method of communication as it has a lower environmental impact. Our communication may involve sharing information with you as well as receiving it from you. We collect and store your Personal Information in the following ways:</p>
        
        <div class="mt-6">
            <h3 class="text-xl font-semibold mb-3">When You Provide Personal Information on Our Platform</h3>
            <p>Mashhoor gathers and stores the Personal Information you provide while using our Platform. This includes information you enter during the registration process or while interacting with our services. For example, you may share your name, address, email, and other details when:</p>
            <ul class="list-disc pl-6 mt-3 space-y-2">
                <li>Registering</li>
                <li>Making a purchase</li>
                <li>Receiving product information</li>
                <li>Subscribing to newsletters</li>
                <li>Contacting customer service</li>
                <li>Participating in surveys</li>
            </ul>
            <p class="mt-3">For your privacy protection, we advise that you only provide the requested information that you are comfortable sharing. If you choose not to share certain details, you may not be able to access all features of the Platform.</p>
        </div>
        
        <div class="mt-6">
            <h3 class="text-xl font-semibold mb-3">Automatic Information Collection</h3>
            <p>Mashhoor automatically collects certain types of information when you interact with our Platform. This includes data about your use of the Platform, interactions with content, and services available to you.</p>
            <p class="mt-3">Like many websites, we collect unidentifiable information using technologies such as:</p>
            <ul class="list-disc pl-6 mt-2 space-y-1">
                <li>Cookies</li>
                <li>Tags</li>
                <li>Web beacons</li>
            </ul>
            <p class="mt-3">Your browser automatically sends some of this information, like the website you visited before ours and your browser version. These technologies help us improve your experience by personalizing content, analyzing usage trends, and enhancing our services. Some features of the Platform may not function properly without these technologies.</p>
            <p class="mt-3">The information gathered through these methods cannot identify you unless combined with other identifiable data. We may also collect information about your device and location, including unique device identifiers.</p>
        </div>
        
        <div class="mt-6">
            <h3 class="text-xl font-semibold mb-3">Information from Other Sources</h3>
            <p>We may obtain information about you from third parties, such as:</p>
            <ul class="list-disc pl-6 mt-2 space-y-2">
                <li>Updated delivery addresses, which help us maintain accurate records and streamline future orders</li>
                <li>Information from third-party sites featuring our Products or promotions, especially if you opt-in to receive updates from us</li>
                <li>Data through third-party applications or social media platforms, if you permit us (or the third party) to share your Personal Information</li>
                <li>Marketing or demographic data from other sources to better tailor our offerings to your preferences</li>
            </ul>
            <p class="mt-3">Please note that Mashhoor is not responsible for the privacy practices of external websites we do not own or control.</p>
        </div>
    </section>

    <!-- Information We Collect Section -->
    <section id="information" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">What Personal Information Do We Collect?</h2>
        </div>
        
        <p>Mashhoor Plus limits itself to gathering information that is essential for providing accurate services, processing your product orders, or handling any applicable refunds or exchanges. This is also done to continually improve our products and services.</p>
        
        <div class="mt-4">
            <p class="font-medium">The following types of personal information are collected and processed by us:</p>
            <ul class="list-disc pl-6 mt-3 space-y-2">
                <li>Your name, email and postal addresses, phone number(s), and country</li>
                <li>Date of birth, language preference, and location</li>
                <li>Publicly available data, including any information about you that is accessible online</li>
                <li>Names of individuals to whom products are shipped, along with their address and phone numbers, as well as IP addresses</li>
                <li>Product preferences and, in some cases, your opinions and preferences</li>
                <li>Records of your product interests and information from future affiliates</li>
                <li>Phone numbers used to contact our customer service</li>
            </ul>
        </div>
        
        <p class="mt-4">We may also collect and use technical data and related information, such as details about your device, system, application software, and peripherals, periodically collected to facilitate software updates, product support, and other related services on our platform.</p>
    </section>

    <!-- Purpose Section -->
    <section id="purpose" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">What is the Purpose for Which the Personal Information is Collected?</h2>
        </div>
        
        <p>Mashhoor Plus may use your personal information for the following purposes:</p>
        
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
            <div>
                <ul class="list-disc pl-6 space-y-2">
                    <li>To verify your identity</li>
                    <li>To fulfill product purchases and transactions</li>
                    <li>To communicate with you regarding your account and activities on our platform</li>
                    <li>To sign you up for newsletters, surveys, or handle marketing communications</li>
                    <li>To improve our services and respond to your requests</li>
                    <li>To address reviews, comments, or other feedback</li>
                    <li>To administer contests, promotions, surveys, or other site features</li>
                    <li>To ask for ratings and reviews of products</li>
                </ul>
            </div>
            <div>
                <ul class="list-disc pl-6 space-y-2">
                    <li>To follow up after correspondence (chat, email, or phone)</li>
                    <li>To enable social media features</li>
                    <li>To comply with legal obligations and enforce terms</li>
                    <li>To understand shopping preferences</li>
                    <li>To conduct marketing and performance research</li>
                    <li>To send order updates and promotional offers</li>
                    <li>To analyze customer demographics and behavior</li>
                    <li>To personalize content and improve services</li>
                </ul>
            </div>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Legal Basis for Processing Personal Information</h3>
            <div class="space-y-3">
                <div>
                    <p class="font-medium">Performance of a Contract:</p>
                    <p>Some personal information is processed because it is necessary for the performance of an agreement with you. For example, processing personal data for delivering the products you have ordered from our platform.</p>
                </div>
                <div>
                    <p class="font-medium">Legitimate Interest:</p>
                    <p>In certain cases, legitimate interests may apply, such as sending you marketing materials, or communicating with you to improve your experience.</p>
                </div>
                <div>
                    <p class="font-medium">Compliance with Legal Obligation:</p>
                    <p>In some instances, processing is necessary to comply with a legal obligation, such as retaining business records to meet local legal requirements.</p>
                </div>
                <div>
                    <p class="font-medium">Consent:</p>
                    <p>In limited cases, we may rely on your consent to process your personal information. You will be asked for consent at the time of data provision, and you can withdraw consent at any time by contacting us via email at mashhoorplus&#64;gmail.com.</p>
                </div>
            </div>
        </div>
        
        <div class="mt-6">
            <p>We may also collect or generate anonymized and aggregated information based on your use of the platform. This information is not identifiable and is used for various purposes such as improving the platform's performance, identifying bugs, and for internal analysis and research. We may share this anonymized data with third parties.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Social Media Interaction</h3>
            <p>Mashhoor Plus maintains a presence on various social media platforms like Facebook, Instagram, LinkedIn, and Twitter. By interacting with us on social media—such as entering contests, posting content, or sharing material from our platform—we may collect information such as your user ID, profile picture, photos you post, and other relevant data. The use of such data is governed by this privacy policy and the terms and conditions of the social media platforms. Your social media interactions are controlled by the privacy settings you have set on those platforms.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Payment Information</h3>
            <p>When making purchases through our platform, payment information is provided directly to PCI-DSS-compliant service providers, and Mashhoor Plus does not store or process your payment details directly, except as stated herein. These intermediaries are strictly prohibited from storing or using your billing information except for the purpose of processing payments on our behalf.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Security & Confidentiality</h3>
            <p>You are responsible for maintaining the confidentiality of your account access details and password. It is your responsibility to restrict access to your devices, and you agree to accept responsibility for all activities that occur under your password. We cannot secure any information you release on your own or that is shared with third parties to whom you have granted access.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Customer Care Support</h3>
            <p>For quality assurance and training purposes, calls to our customer care support may be recorded.</p>
        </div>
    </section>

    <!-- Sharing Section -->
    <section id="sharing" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">How We Share Personal Information</h2>
        </div>
        
        <p>Only authorized personnel at Mashhoor Plus will have access to your Personal Information. We may share your information with the following parties, who either adhere to this Policy or follow practices that are at least as protective as those outlined here:</p>
        
        <ul class="list-disc pl-6 mt-4 space-y-3">
            <li>Our affiliates and third-party partners.</li>
            <li>Service providers acting on our behalf, such as logistics partners. These providers are authorized to use your information only as necessary to perform services or comply with legal requirements.</li>
            <li>In the event of a merger or sale of our business, we may transfer or disclose your Personal Information to the new business entity for evaluating the transaction or managing operations, subject to this Policy.</li>
            <li>Personal Information may be shared with our corporate affiliates to help detect and prevent fraud, abuse, or illegal activities, or to correlate related accounts.</li>
            <li>Third-party service providers may be used for various functions, such as order processing, courier services, customer support, and more. These providers will access Personal Information only as required to perform their duties and must follow this Policy.</li>
            <li>You may also be offered opportunities to share your information with third parties for specific promotions or events, in which case your information will be shared only with your consent.</li>
            <li>We may disclose your Personal Information if required by law or to protect the safety of individuals, property, or public interests.</li>
        </ul>
        
        <div class="bg-blue-50 border-l-4 border-blue-500 p-4 mt-6">
            <p class="font-medium">Important:</p>
            <p class="mt-2">We do not sell or rent your Personal Information to third parties.</p>
        </div>
    </section>

    <!-- Retention Section -->
    <section id="retention" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Retention of Personal Information</h2>
        </div>
        
        <p>We retain your Personal Information only as long as it is necessary for its intended purposes or as required by applicable laws. This ensures we comply with legal, administrative, and accounting obligations. We implement safeguards to protect your Personal Information against unauthorized access or misuse.</p>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Storage of Personal Information</h3>
            <p>Your Personal Information is stored securely on our servers or cloud services. Third-party storage providers are required to maintain security measures consistent with this Policy.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Disposal of Personal Information</h3>
            <p>We ensure that any Personal Information used for our services is kept safe and disposed of securely once it is no longer needed.</p>
        </div>
    </section>

    <!-- Opting Out Section -->
    <section id="opting" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Opting Out</h2>
        </div>
        
        <p>Mashhoor Plus gives you options to opt-out of receiving marketing communications:</p>
        
        <div class="space-y-4 mt-4">
            <div>
                <p class="font-medium">Opting Out of Marketing Communications:</p>
                <p>If you no longer wish to receive promotional content, you can unsubscribe via the link in the email or contact our customer service.</p>
            </div>
            
            <div>
                <p class="font-medium">Updating Personal Information:</p>
                <p>You can update your contact details, preferences, or account information by logging into your account.</p>
            </div>
            
            <div>
                <p class="font-medium">Removing Customer Review Content:</p>
                <p>You may request to remove content from public spaces such as reviews by emailing us. We will attempt to fulfill this request, but some historical copies may remain.</p>
            </div>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Withdrawal of Consent</h3>
            <p>If you've provided consent to use or disclose your Personal Information, you can withdraw it by contacting us. However, we may retain information to fulfill legal obligations or resolve disputes.</p>
        </div>
    </section>

    <!-- Cookies Section -->
    <section id="cookies" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Do We Use Cookies?</h2>
        </div>
        
        <p>Yes, we use cookies to enhance your experience by tracking preferences and activities on our platform. Cookies help make subsequent visits more efficient. You can block cookies in your browser settings, but some functionality may be limited.</p>
        
        <div class="mt-4">
            <p class="font-medium">We use cookies for:</p>
            <ul class="list-disc pl-6 mt-2 space-y-2">
                <li>Storing customer preferences</li>
                <li>Tracking advertisements</li>
                <li>Analyzing site traffic to improve our services</li>
            </ul>
        </div>
        
        <p class="mt-4">You can manage cookies through your browser settings, but disabling them may affect your experience.</p>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Customer Comments and Content</h3>
            <p>If you post content on our platform, be aware that third parties may access and use this information. We are not responsible for how others use publicly posted content.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Links to Third-Party Websites</h3>
            <p>Our platform may contain links to external websites. We are not responsible for the content, security, or privacy practices of these sites, and we recommend reviewing their policies before visiting.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Third-Party Analytics</h3>
            <p>We use third-party services like Google and Meta for analytics. These services use cookies to track your interactions with our platform. You can opt out of this data collection through their respective settings.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Children's Privacy</h3>
            <p>Mashhoor Plus is not intended for individuals under the age of 18, and we do not knowingly collect information from minors. If we become aware of such information being collected, we will delete it.</p>
        </div>
    </section>

    <!-- Security Section -->
    <section id="security" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Security Measures</h2>
        </div>
        
        <p>We take multiple steps to protect your Personal Information, including:</p>
        
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mt-4">
            <div class="bg-gray-50 p-4 rounded-lg">
                <h4 class="font-semibold mb-2">Physical Security</h4>
                <ul class="list-disc pl-6 space-y-1">
                    <li>Restricted access to offices</li>
                    <li>Secure storage facilities</li>
                </ul>
            </div>
            
            <div class="bg-gray-50 p-4 rounded-lg">
                <h4 class="font-semibold mb-2">Technical Security</h4>
                <ul class="list-disc pl-6 space-y-1">
                    <li>Encryption protocols</li>
                    <li>Firewall protection</li>
                    <li>Password security</li>
                </ul>
            </div>
            
            <div class="bg-gray-50 p-4 rounded-lg">
                <h4 class="font-semibold mb-2">Organizational Security</h4>
                <ul class="list-disc pl-6 space-y-1">
                    <li>Confidentiality agreements</li>
                    <li>Staff training programs</li>
                </ul>
            </div>
        </div>
        
        <div class="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-6">
            <p>We use secure methods to process and store your Personal Information. Although we work hard to protect your data, no system is completely secure, and we are not responsible for unauthorized access by third parties.</p>
        </div>
        
        <div class="mt-8">
            <h3 class="text-xl font-semibold mb-3">Policy Review</h3>
            <p>Please note that we review and may make changes to this Policy from time to time. When changes are made, the Policy link will include a notation "Revised (date)," indicating that you should review the new terms. The updated terms will be effective immediately upon posting on this page, with an updated effective date. By accessing the Platform after any changes have been made, you signify your agreement on a prospective basis to the modified Policy and any changes contained therein.</p>
        </div>
    </section>

    <!-- Privacy Concerns Section -->
    <section id="concerns" class="mb-10">
        <div class="border-b border-gray-200 pb-2 mb-6">
            <h2 class="text-2xl font-bold text-primary">Privacy Concerns</h2>
        </div>
        
        <p>If you are concerned about the handling of your Personal Information, or if you have any complaints or queries related to your Personal Information or our Policy, please contact:</p>
        
        <div class="bg-gray-50 p-6 rounded-lg mt-4">
            <h3 class="font-semibold text-lg mb-3">Mashhoor Plus</h3>
            <div class="space-y-2">
                <p><span class="font-medium">Phone:</span> +91 8273363610</p>
                <p><span class="font-medium">Email:</span> <a href="mailto:mashhoorplus&#64;gmail.com" class="text-primary hover:underline">mashhoorplus&#64;gmail.com</a></p>
            </div>
            <p class="mt-4 text-sm italic">The Grievance Officer is identified above pursuant to the provisions of applicable laws, including but not limited to the Information Technology Act, 2000, and the Consumer Protection Act, 2019, and the rules enacted under those laws.</p>
        </div>
    </section>
</div>